module.exports = __webpack_public_path__ + "static/media/mentalDisorders.6794bc5d.svg";